// extracted by mini-css-extract-plugin
module.exports = {"customDialog":"Modal_customDialog__tTXvJ","modalHeader":"Modal_modalHeader__2hBTe"};